<div class="h-screen w-screen grid" style="grid-template-rows: 64px 1fr;">
  <app-header/>

  <div class="grid h-full" style="grid-template-columns: auto 1fr;">
    <app-navigation [open]="sidebarOpen()" (toggled)="toggleSidebar()"/>

    <main class="h-full overflow-auto bg-slate-50 p-4 sm:p-6">
      <router-outlet/>
    </main>
  </div>
</div>
